<div [formGroup]="itemForm" class="sale-item-fields">
  @if (showSaleItemTypeFlag && isAdmin) {
<div class="field-group">
    <div class="field-label">
      <span>Sale Item Type</span>
      <span seFePopoverTrigger="saleItemPopover">
        <se-fe-icon
          seFeDataName="question_circle"
          seFeDataSize="600">
        </se-fe-icon>
      </span>
      <se-fe-popover seFePopoverName="saleItemPopover">
        If a cart ONLY contains safety sale items, the fee will automatically be reduced to zero.
      </se-fe-popover>
    </div>
    <se-fe-form-field-select
      class="sale-item-type-dropdown"
      formControlName="zeroRateType"
      seFeDataAriaLabel="Sale Item Type"
      seFeDataPlaceholder="Registration and Invoicing"
      [seFeDataOptions]="zeroRateTypeList">
    </se-fe-form-field-select>
  </div>
}

  <div class="field-group">
    <se-fe-form-field [seFeDataConfig]="skuFieldConfig">
      <se-fe-form-field-text
      formControlName="sku"
      seFeDataAutoComplete="off"
      maxlength="64">
      </se-fe-form-field-text>
      <div seFeHelp>
        A unique code that helps to distinguish sale items from others with similar names.
      </div>
    </se-fe-form-field>
  </div>

  @if (!!itemVariation.tax_code) {
<div class="field-group">
    <se-fe-form-field [seFeDataConfig]="taxCodeFieldConfig">
      <se-fe-form-field-text
      formControlName="taxCode"
      seFeDataAutoComplete="off"
      seFeDataPlaceholder="PC123456">
      </se-fe-form-field-text>
    </se-fe-form-field>
  </div>
}

  @if (displayReferenceCode && referenceCodeReady) {
<div class="field-group">
    <label for="referenceCode">Reference Code <span class="optional-label">(optional)</span></label>
    <se-fe-form-field-multiselect
      #referenceCodeField
      id="referenceCode"
      formControlName="referenceCode"
      [seFeDataEnableAddNew]="true"
      seFeDataMaxInput="1"
      [seFeDataHideSearchIcon]="true"
      [seFeDataOptions]="referenceCodeOptions"
      [seFeDataQueryValidators]="referenceCodeQueryValidators"
      [seFeDataComfy]="false"
      seFeDataNotFoundMessage="Press Enter to add a new reference code"
      [seFeDataQueryConfig]="referenceCodeConfig">
    </se-fe-form-field-multiselect>
    <span class="field-help">
      Enter or choose a reference code. Codes, like general ledger codes, can be used to organize sale item purchases on financial reports.
      Codes will be saved to use again in the future.
    </span>
  </div>
}

  <hr />

  <div class="field-group">
    <se-fe-form-field [seFeDataConfig]="priceFieldConfig">
      <se-fe-form-field-text
        formControlName="price"
        seFeDataAutoComplete="off"
        seFeDataPlaceholder="0.00"
        (change)="setDisabled(); onUpfrontAmountChange(); setPaymentPlanText()"
        (blur)="onPriceChange()">
        <se-fe-icon
          seFeFormFieldTextBefore
          seFeDataName="dollar"
          seFeDataSize="500">
        </se-fe-icon>
      </se-fe-form-field-text>
    </se-fe-form-field>
  </div>

<div class="price-variations">
    @for (priceVariation of priceVariations; track priceVariation; let i = $index) {

      @if (priceVariation.show) {
<app-price-variation

        [priceVariation]="priceVariation"
        [priceVariationDates]="priceVariationDates"
        [priceVariationNames]="priceVariationNames"
        (remove)="handlePriceVariationRemove(priceVariation, i)"
        [saleItemType]="$safeNavigationMigration(itemForm.get('zeroRateType')?.value)"
        [partialAmountDueUpFrontSelected]="isPartialAmount()"
        [componentIndex]="i"
        [savedPriceSchedules]="savedPriceSchedules">
      </app-price-variation>
}

}

    <div class="add-price-variation-button">
      <se-fe-button seFeDataEmphasis="low" [seFeDataSmall]="true" (click)="handlePriceVariationButtonClick()">
        {{ priceVariations.length === 0 ? 'Add a price variation' : 'Add another price variation'}}
      </se-fe-button>
      <div class="field-help">
        Price variations allow you to set different prices based on date ranges, perfect for things like “Early Bird”
        pricing or adding a late fee to late registrations.
      </div>
    </div>
  </div>

  <hr />

  <div class="upfront-amount-container">
    <div class="field-label">Upfront Payment Options</div>
    <div class="field-help">
      Choose how much of this item’s price will be due right away when this item is sold. Any amount left over may be paid on a payment plan.
    </div>

    <div class="payment-options">
      <se-fe-radios
        [(ngModel)]="upfrontAmountOption"
        [ngModelOptions]="{ standalone: true }"
        [seFeDataOptions]="upfrontAmountOptions"
        (ngModelChange)="onUpfrontAmountOptionChanged($event)">
      </se-fe-radios>

      @if (isPartialAmount()) {
<div class="payment-option payment-option--with-field">

        <div class="partial-amount-section">
          <se-fe-form-field class="partial-amount-text-field" [seFeDataConfig]="upfrontAmountFieldConfig">
            <se-fe-form-field-text
              [seFeDataReadOnly]="isUpfrontAmountReadOnly()"
              (click)="onUpfrontAmountOptionChanged('partialAmount')"
              (change)="setPaymentPlanText()"
              (blur)="onUpfrontAmountChange()"
              (focus)="setUpfrontAmountFocus()"
              seFeDataAutoComplete="off"
              formControlName="upfrontAmount"
              seFeDataPlaceholder="0.00">
              <se-fe-icon seFeFormFieldTextBefore seFeDataName="dollar" seFeDataSize="500"></se-fe-icon>
            </se-fe-form-field-text>
          </se-fe-form-field>
          @if (isPartialAmount() && maximumUpfrontAmount) {
<span class="field-help">
            {{ 'Up to $' + maximumUpfrontAmount }}
          </span>
}
        </div>
      </div>
}
    </div>
  </div>
</div>
